

import { Button, Form, message, Select, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { InputField, InputMasker, SelectField, SelectFields } from '../../layouts/FormFields';
import axios from 'axios';
import getHeaders from '../../utils/authHeaders';
import LoaderImage from '../LoaderImage';
import { app } from '../../config';
import { LoadingOutlined } from '@ant-design/icons';

const AddDiscount = ({ show, setShow, handleClose = () => {}, setisRender, loader, setLoader, products }) => {
  const [form] = Form.useForm();
  const [phoneNumber, setPhoneNumber] = useState();
  const [prodval, setprodval] = useState();
  const [isDisabled,setisDisabled]=useState(false)

const [errorType, setErrorType] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const submit = async (values) => {
    try {
      let resp = await axios.post(`${app.URL}/api/v1/admin/discount-percentage/create`, values, { headers: getHeaders() });
      // let resp = await axios.post(`http://localhost:3200/api/v1/admin/affiliateparent/create`, values, { headers: getHeaders() });

      console.log(resp);
      if (resp.status == 200) {
        form.resetFields(); // Reset form fields after successful submission
        // setLoader(true);

        setShow(false); // Close modal
        // setisRender(true);
        setisDisabled(true)
      }
    } catch (error) {
      console.log(error);
        setisDisabled(true);

    }
  };

  const onFinish = (values) => {
    console.log('values', values);
      //   return
      if (!prodval) {
        setErrorMsg('Select a product');
          setErrorType('cat');
          return
      }
    let payload = {
      ...values,
      productId: prodval,
    };
    setisDisabled(true)
    console.log('payload', payload);
      // return
    submit(payload);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Form Submission Failed:', errorInfo);
  };
  // const getParents = async () => {
  //   try {
  //     let resp = await axios.get(`http://localhost:3200/api/v1/admin/faqparent/listing`);
  //     console.log('response', resp?.data?.result?.data);
  //     if (resp.status == 200) {
  //       setParentElemments(resp?.data?.result?.data);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // useEffect(() => {
  //   getParents();
  // }, []);
  const staticElements = [
    { faqparentCategoryId: 1, categoryName: 'Category 1' },
    { faqparentCategoryId: 2, categoryName: 'Category 2' },
  ];
 
    console.log('parentElements', prodval);
  return (
    <>
      {/* {loader && <LoaderImage />} */}
      {/* {!loader && ( */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Discount </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            form={form}
            name='basic'
            initialValues={{
              ['isActive']: 1,
            }}
            autoComplete='off'
            className='row  px-3 pb-3'
            onFinish={onFinish} // This will handle form submission
            onFinishFailed={onFinishFailed} // This will handle form validation failure
          >
            <div className='row'>
              {/* <div className='form-flo/ating'> */}
              <div className='col-md-12 mb-4 '>
                <div className='form-floating'>
                  <select
                    onChange={(e) => {
                      setprodval(e.target.value);

                      setErrorMsg('');
                      setErrorType('');
                    }}
                    value={prodval}
                    className='form-select'
                    id='floatingSelectGrid'
                  >
                    <option value=''>
                      <span className='text-muted'>Open to select product</span>
                    </option>
                    {products.map((item) => (
                      <option value={item.productId}>{item.name}</option>
                    ))}
                  </select>
                  {/* <label for='floatingSelectGrid'>Render Type</label> */}
                  {errorType === 'cat' && <span className='ant-form-item-explain-error'>{errorMsg}</span>}
                </div>
              </div>

              <Form.Item
                colon={false}
                className='mt-3'
                name='rangeFrom'
                rules={[
                //   { required: true, message: 'Enter RangeFrom' }, // Validation rule to prevent empty submission
                ]}
              >
                <InputField
                  col='col-md-12 col-12'
                  name='rangeFrom'
                  //   maxLength={3}
                  // label='Name'
                  placeholder='Enter RangeFrom'
                  rules={[
                    {
                      required: true,
                      message: 'Enter RangeFrom',
                    },
                  ]}
                  onKeyPress={(e) => {
                    const charCode = e.charCode;
                    if (charCode < 48 || charCode > 57) {
                      e.preventDefault(); // Prevent non-numeric characters
                    }
                  }}
                  onChange={(e) => {}}
                />
              </Form.Item>
{/*              
             
                          <Form.Item name='rangeFrom' colon={false} className=''>
                <InputField
                  col='col-md-12 col-12'
                  className='p-0'
                  placeholder='Enter RangeFrom'
                  rules={[
                    {
                      required: true,
                      message: 'Enter RangeFrom',
                    },
                  ]}
                  //   maxLength={3} // Max 3 digits (for numbers up to 100)
                  onKeyPress={(e) => {
                    const charCode = e.charCode;
                    if (charCode < 48 || charCode > 57) {
                      e.preventDefault(); // Prevent non-numeric characters
                    }
                  }}
                  onChange={(e) => {
                    // const value = e.target.value;
                    // if (value && (Number(value) < 0 || Number(value) > 100)) {
                    //   e.target.value = value.slice(0, -1); // Remove invalid input
                    // }
                  }}
                />
                          </Form.Item>
                          

                           */}
              {/* 
              <Form.Item
                name='rangeTo'
                colon={false}
                className=''
                rules={[
                  { required: true, message: 'Enter RangeTo' }, // Validation rule to prevent empty submission
                ]}
              >
                <InputField
                  col='col-md-12 col-12'
                  className='p-0'
                  placeholder='Enter RangeTo'
                  rules={[
                    {
                      required: true,
                      message: 'Enter RangeTo',
                    },
                  ]}
                  //   maxLength={3} // Prevents more than 3 characters (100 max)
                  onKeyPress={(e) => {
                    const charCode = e.charCode;
                    if (charCode < 48 || charCode > 57) {
                      e.preventDefault(); // Restrict to numbers only
                    }
                  }}
                  onChange={(e) => {
                    // let value = e.target.value;
                    // if (value && (Number(value) < 0 || Number(value) > 100)) {
                    //   e.target.value = value.slice(0, -1); // Remove invalid input
                    // }
                  }}
                />
 */}
              {/* <InputField
                  col='col-12'
                //   rules={[
                //     {
                //       required: true,
                //       message: ' Enter Contact',
                //     },
                //   ]}
                  placeholder='Contact '
                  name='contact'
                  label='Contact '
                //   required={true}
                /> */}
              {/* </Form.Item> */}
              <Form.Item colon={false} className='' name='rangeTo'>
                <InputField
                  col='col-md-12 col-12'
                  name='rangeTo'
                  //   maxLength={3}
                  // label='Name'
                  placeholder='Enter RangeTo'
                  rules={[
                    {
                      required: true,
                      message: 'Enter RangeTo',
                    },
                  ]}
                  //   maxLength={3} // Prevents more than 3 characters (100 max)
                  onKeyPress={(e) => {
                    const charCode = e.charCode;
                    if (charCode < 48 || charCode > 57) {
                      e.preventDefault(); // Restrict to numbers only
                    }
                  }}
                  onChange={(e) => {
                    // let value = e.target.value;
                    // if (value && (Number(value) < 0 || Number(value) > 100)) {
                    //   e.target.value = value.slice(0, -1); // Remove invalid input
                    // }
                  }}
                />
              </Form.Item>
              <Form.Item
                colon={false}
                className=''
                rules={[
                  { required: true, message: 'Enter Percentage' }, // Validation rule to prevent empty submission
                ]}
              >
                <InputField
                  col='col-md-12 col-12'
                  name='percentage'
                  //   maxLength={3}
                  // label='Name'
                  placeholder='Enter Percentage'
                  rules={[
                    {
                      required: true,
                      message: 'Enter Percentage',
                    },
                  ]}
                  onKeyPress={(e) => {
                    let next = e.key;
                    let value = e.target.value;
                    console.log('e', e.target.value, typeof next, typeof value);

                    if (value && next && Number(value + next) > 100) {
                      console.log('in');
                      e.preventDefault();
                      return;
                    }
                    console.log('e', e.target.value, e);
                    const charCode = e.charCode;
                    if (charCode == 46) {
                      return;
                    }
                    if (charCode < 48 || charCode > 57) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {}}
                />
              </Form.Item>
              {/* <div className='col-lg-12 mb-2 ms-3'>
                <Form.Item label='Active' className='selector-main' colon={false} valuePropName='checked' name='isActive'>
                  <Switch />
                </Form.Item>
              </div> */}
              <div className='col-12'>
                <div className='row justify-content-center'>
                  <button onClick={() => setShow(false)} htmlType='button' type='primary' className='btn btn-primary button patient-cancel-btn col-md-5 mr-2 mb-2'>
                    Cancel
                  </button>

                  <button disabled={isDisabled} type='primary' class='btn btn-primary button col-md-5 mb-2' htmlType='submit'>
                    {loader ? <LoadingOutlined /> : 'Save'}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* )} */}
    </>
  );
};

export default AddDiscount;
